import React from 'react';
import { connect } from 'react-redux';

// Multibrand-UI Components
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Container from '@zg-rentals/multibrand-ui/lib/Container';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import Edit from '@zg-rentals/multibrand-ui/lib/icons/Edit';
import Trending from '@zg-rentals/multibrand-ui/lib/icons/Trending';

// selectors
import {
    AddressSelectors,
    AppSelectors,
    PropertiesSelectors,
    RoutingSelectors,
} from 'app/shared/selectors';

// components
import Page from 'app/shared/containers/Page';
import HeadWrapper from 'app/shared/components/HeadWrapper';
import PageHeroContainer from 'app/shared/components/PageHero/PageHeroContainer';

// static images
import zrmSampleRentalsImgSrc from 'app/shared/images/zrm-sample-rentals-nearby@2x.png';

// Stylesheets
import './style.scss';

class PriceRentalLandingPage extends React.Component {
    renderSectionRentalPrices() {
        return (
            <div className="PriceRentalLandingPage-Section">
                <Text className="PriceRentalLandingPage-Section-Title" type="h4">
                    See Local Rental Prices
                </Text>

                <div className="PriceRentalLandingPage-Row-Item">
                    <Trending
                        className="PriceRentalLandingPage-Row-Item-Icon"
                        colorType="marketing"
                        size={30}
                    />

                    <div className="PriceRentalLandingPage-Row-Item-Content">
                        <Text className="PriceRentalLandingPage-Row-Item-Title" type="h4">
                            Compare similar rentals
                        </Text>
                        <Text thin={true} type="body">
                            Determine what you should charge based on comparable rental homes in your area.
                        </Text>
                    </div>
                </div>

                <div className="PriceRentalLandingPage-Row-Item">
                    <Edit
                        className="PriceRentalLandingPage-Row-Item-Icon"
                        colorType="marketing"
                        size={30}
                    />

                    <div className="PriceRentalLandingPage-Row-Item-Content">
                        <Text className="PriceRentalLandingPage-Row-Item-Title" type="h4">
                            Fine-tune your pricing
                        </Text>
                        <Text thin={true} type="body">
                            Compare your home to nearby rentals with similar square footage, bedrooms and bathrooms.
                        </Text>
                    </div>
                </div>
            </div>
        );
    }

    renderSectionRentZestimate() {
        const learnMoreUrl = 'https://www.zillow.com/rental-manager/resources/what-is-the-rent-zestimate/';
        const linkTarget = '_blank';

        return (
            <div className="PriceRentalLandingPage-Section">
                <Text className="PriceRentalLandingPage-Section-Title" type="h4">
                    Get the Rent Zestimate®
                </Text>

                <Text thin={true} type="body">
                    Use Zillow’s estimated monthly rent price as a starting point for pricing your rental properties.
                </Text>

                <Link href={learnMoreUrl} target={linkTarget}>
                    <Text type="body">Learn more</Text>
                </Link>
            </div>
        );
    }

    renderSampleRentalsImg() {
        return (
            <div className="ImgContainer">
                <img className="Img" src={zrmSampleRentalsImgSrc} alt="ZRM sample rentals" />
            </div>
        );
    }

    render() {
        const { addressList } = this.props;

        const pageTitle = 'How much can I charge for rent? – Rent Comp Estimator';

        return (
            <div className="PriceRentalLandingPage">
                <HeadWrapper
                    title={pageTitle}
                />

                <PageHeroContainer
                    className="PriceRentalLandingPage-Main"
                    hasGradient={true}
                    addressList={addressList}
                />
                <Page noPadding={true}>
                    <Container className="PriceRentalLandingPage-Container Container-ZSG-Breakpoints">
                        <Row>
                            <Col>
                                <div className="PriceRentalLandingPage-Content">
                                    <Row>
                                        <Col lg={4}>
                                            {this.renderSectionRentalPrices()}
                                            {this.renderSectionRentZestimate()}
                                        </Col>
                                        <Col lg={8}>
                                            {this.renderSampleRentalsImg()}
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Page>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    addressList: AddressSelectors.makeAddressList(state),
    brand: AppSelectors.makeBrand(state),
    properties: PropertiesSelectors.makeProperties(state),
    queryString: RoutingSelectors.makeSearch(state),
});

export { PriceRentalLandingPage };
export default connect(mapStateToProps)(PriceRentalLandingPage);
